import { KomponentenTypEnum, OptionalKomponentenTypEnum } from '../components/ParamComponents';
import { ISelectOption } from 'react-ocean-forms-bootstrap';
import { ComponentService } from './ComponentService';


/**
 * util service for component type 
 */
class KomponentenTypUtilImpl {


  getOptionalComponentOptionForEnum(typ: OptionalKomponentenTypEnum): ISelectOption | undefined {
    try {
      return this.getComponentOptionForEnum(typ);
    }
    catch(e) {
      return undefined;
    }
  }

  getComponentOptionForEnum(typ: OptionalKomponentenTypEnum): ISelectOption {

    const list = ComponentService.getComponentTypes();

    let compTyp: ISelectOption | undefined;
    list.forEach((e) => {
      if(e.id === typ) {
        compTyp = { label: e.name, value: e.id};
      }
    });
    if (compTyp) return compTyp; 
    throw new Error('Komponente nicht definiert.');
  }

  getComponentTypeEnum(value: string): KomponentenTypEnum {
    let komponenteEnum: KomponentenTypEnum | undefined;
    Object.keys(KomponentenTypEnum).forEach( key => {
      if(KomponentenTypEnum[key] === value) {
        komponenteEnum = KomponentenTypEnum[key];
      }
    });
    if(komponenteEnum) {
      return komponenteEnum
    }
    throw new Error('Komponente nicht definiert.');
  }

  getComponentName(type: OptionalKomponentenTypEnum): string {
    if(type) { 
      const list = ComponentService.getComponentTypes();
      const result =list.find((e) => {
        if(e.id == type) {
          return e;
        }
      }); 
      if(result) return result.name;
    }
    throw new Error('Komponente nicht definiert');
  }

}


export const KomponentenTypUtil = new KomponentenTypUtilImpl();
